const origin = 'https://blog.qxbase.com'
export const homeTitle = 'QXBase 博客 | Java、Vue 与开发实践'
const homeDescription = '青旬的 QXBase 技术博客，分享 Java、Spring Boot、Vue、算法题解与实际开发问题的解决经验。'
function meta(name, content) {
  const key = name.startsWith('og:') ? 'property' : 'name'
  let el = document.head.querySelector(`meta[${key}="${name}"]`)
  if (!el) { el = document.createElement('meta'); el.setAttribute(key, name); document.head.appendChild(el) }
  el.setAttribute('data-seo', ''); el.content = content
}
export function setSeo({ title, description = homeDescription, path, hidden = false, article = null }) {
  document.head.querySelectorAll('[data-seo],meta[data-article-robots]').forEach(el => el.remove())
  document.title = title
  meta('description', description)
  meta('robots', hidden ? 'noindex, nofollow, noarchive' : 'index, follow, max-image-preview:large')
  meta('og:title', title); meta('og:description', description); meta('og:url', origin + path)
  meta('og:site_name', 'QXBase 博客'); meta('og:type', article ? 'article' : 'website')
  const canonical = document.createElement('link'); canonical.rel = 'canonical'; canonical.href = origin + path; canonical.dataset.seo = ''; document.head.appendChild(canonical)
  if (path === '/' && !hidden) {
    const script = document.createElement('script'); script.type = 'application/ld+json'; script.dataset.seo = ''; script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@type': 'WebSite', name: 'QXBase 博客', alternateName: 'QXBase', url: origin + '/' }); document.head.appendChild(script)
  }
  if (article && !hidden) {
    const data = { '@context': 'https://schema.org', '@type': 'BlogPosting', headline: article.subject, url: origin + path, mainEntityOfPage: origin + path, author: { '@type': 'Person', name: article.userName || '青旬' } }
    const iso = value => value && /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}$/.test(value) ? value.replace(' ', 'T') + '+08:00' : value
    if (article.releaseTime) data.datePublished = iso(article.releaseTime)
    // Legacy updateTime changes with view counts, so it is not a content modification date.
    if (article.img && article.img.startsWith('/media/')) { data.image = [origin + article.img]; meta('og:image', data.image[0]) }
    const script = document.createElement('script'); script.type = 'application/ld+json'; script.dataset.seo = ''; script.textContent = JSON.stringify(data); document.head.appendChild(script)
  }
}
export function routeSeo(to) {
  // Preserve server-provided article metadata until the detail response arrives.
  if (to.name === 'essay') return
  setSeo({ title: to.path === '/' ? homeTitle : 'QXBase 博客', path: to.path, hidden: to.path !== '/' })
}
export function articleSeo(article) {
  const doc = new DOMParser().parseFromString(article.content || '', 'text/html')
  doc.querySelectorAll('script,style,pre,code,.opt-box,.pre-numbering').forEach(el => el.remove())
  const text = (article.intro || doc.body.textContent || '').replace(/\s+/g, ' ').trim()
  const path = '/essay/' + article.publicId
  setSeo({ title: article.subject + ' | QXBase 博客', description: text.slice(0, 160), path, hidden: Boolean(article.hidden), article })
}
